<div class="relative">
  <button (click)="toggleDropdown()" class="flex items-center text-gray-700 dropdown-toggle dark:text-gray-400">
    <span class="mr-3 overflow-hidden rounded-full h-11 w-11">
      <img [src]="perfilImageSrc || 'assets/images/Partner-Core-No-Image.webp'" [alt]="'common.userPhoto' | transloco" class="h-full w-full object-cover" />
    </span>
    <span class="block mr-1 font-medium text-theme-sm">{{ firstnameUSer() }}</span>
    <svg [ngClass]="{
        'stroke-gray-500 dark:stroke-gray-400 transition-transform duration-200': true,
        'rotate-180': isOpen
      }" width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M4.3125 8.65625L9 13.3437L13.6875 8.65625" stroke="currentColor" stroke-width="1.5"
        stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  </button>

  <app-dropdown [isOpen]="isOpen" (close)="closeDropdown()"
    className="absolute right-0 mt-[17px] flex w-[260px] flex-col rounded-2xl border border-gray-200 bg-white p-3 shadow-theme-lg dark:border-gray-800 dark:bg-gray-dark">
    <div>
      <span class="block font-medium text-gray-700 text-theme-sm dark:text-gray-400">
        {{ firstnameUSer() }} {{ lastnameUSer() }}
      </span>
      <span class="mt-0.5 block text-theme-xs text-gray-500 dark:text-gray-400">
        {{ emailUser() || ('common.noEmail' | transloco) }}
      </span>
    </div>

    <ul class="flex flex-col gap-1 pt-4 pb-3 border-b border-gray-200 dark:border-gray-800">
      <li>
        <app-dropdown-item-two (itemClick)="closeDropdown()" tag="a" [to]="profileUrl()"
          className="item-icon-size-system flex items-center gap-3 px-3 py-2 font-medium text-gray-700 rounded-lg group text-theme-sm hover:bg-gray-100 hover:text-gray-700 dark:text-gray-400 dark:hover:bg-white/5 dark:hover:text-gray-300">
          <i class="bi bi-person-circle"></i>
          {{ 'layout.userMenu.editProfile' | transloco }}
        </app-dropdown-item-two>
      </li>
      <li>
        <app-dropdown-item-two (itemClick)="closeDropdown()" tag="a" [to]="'/configuracion'"
          className="item-icon-size-system flex items-center gap-3 px-3 py-2 font-medium text-gray-700 rounded-lg group text-theme-sm hover:bg-gray-100 hover:text-gray-700 dark:text-gray-400 dark:hover:bg-white/5 dark:hover:text-gray-300">
          <i class="bi bi-gear"></i>
          {{ 'layout.userMenu.settings' | transloco }}
        </app-dropdown-item-two>
      </li>
      <li>
        <app-dropdown-item-two (itemClick)="closeDropdown()" tag="a" [to]="'/soporte'"
          className="item-icon-size-system flex items-center gap-3 px-3 py-2 font-medium text-gray-700 rounded-lg group text-theme-sm hover:bg-gray-100 hover:text-gray-700 dark:text-gray-400 dark:hover:bg-white/5 dark:hover:text-gray-300">
          <i class="bi bi-headset"></i>
          {{ 'layout.userMenu.support' | transloco }}
        </app-dropdown-item-two>
      </li>
    </ul>
    <a (click)="logout()"
      class="item-icon-size-system flex items-center gap-3 px-3 py-2 mt-3 font-medium text-gray-700 rounded-lg group text-theme-sm hover:bg-gray-100 hover:text-gray-700 dark:text-gray-400 dark:hover:bg-white/5 dark:hover:text-gray-300 cursor-pointer">
      <i class="bi bi-arrow-bar-left"></i>
      {{ 'layout.userMenu.logout' | transloco }}
    </a>
  </app-dropdown>
</div>